//messages.js
export default {
	name: "Name",
	name_alias: "Name Alias",
	column_span: "Column Span",
	permission: "Permission",
	active: "Active",
	edit_dashboard_widget: 'Edit Dashboard Widget',
	add_dashboard_widget: 'Add Dashboard Widget',
	delete_dashboard_widget: 'Delete Dashboard Widget',
	dashboard_widgets: 'Dashboard Widgets',
	delete_dashboard_widget_confirm: 'This action is not reversible!',
}